<div class="grid mx-0">
	<div *ngIf="!online" class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
		<i class="pi cm-alert text-2xl pr-1 text-yellow-700"></i>
		<p-tag [value]="('OFFLINE_ALERT' | translate)" severity="warning"></p-tag>
	</div>
</div>
<div *ngIf="!isAccess()" class="grid mx-0" style="padding-top: 10px">
	<div class="col-12 flex align-items-center justify-content-center bg-red-200 p-1 border-round-xl" *ngIf="online">
		<i class="pi cm-alert text-2xl pr-1 text-red-700"></i>
		<p-tag [value]="('PASSWORD_REQUEST_OR_ERR_CON' | translate)" severity="danger"></p-tag>
	</div>
	<div class="col-12 flex justify-content-center">
		<p-button label="{{ 'INSERT_PASSWORD' | translate }}" icon="pi cm-key" size="large"
			(click)="justToogleOpenPassword()" [rounded]="false" [text]="true" severity="danger"
			styleClass="font-bold border-red-600" [disabled]="!online">
		</p-button>
	</div>
</div>

<div class="grid mt-0">
	<div *ngIf="online && isAccess()" class="col-12 pb-0">
		<app-board-users-table></app-board-users-table>
	</div>
	<div class="col-12">
		<p-accordion>
			<!-- <p-accordionTab #boardUsersList (selectedChange)="togglePanel($event)" [disabled]="configured !== 0">
							</p-accordionTab> -->
			<p-accordionTab #importUsersList>
				<ng-template pTemplate="header">
					<div class="grid flex align-items-center w-full pt-2 -mb-2">
						<div [class]="!onExtendedMobile() ? 'col-12' : 'col-12 flex justify-content-center'" class="py-0">
							<span class="font-semibold white-space-nowrap">{{'IMPORT_LIST_USERS' | translate }}</span>
						</div>
					</div>
				</ng-template>
				<div>
					<app-board-users-lists></app-board-users-lists>
				</div>
			</p-accordionTab>
		</p-accordion>
	</div>
</div>
